import React, { Component } from 'react';
import BasicLine from './BasicLine';
import NavBar from '../shared/NavBar';
import { style } from 'd3';

import { Bar } from 'react-chartjs-2';
import {Col, Row, Button, Input} from 'reactstrap';


class Emails extends Component {


    constructor(props) {
        super(props);

        this.state = {
            stats: [],
            teamValue: "Utah Sales Team",
            timeValue: "LAST_WEEK"
        };

        this.teamChange = this.teamChange.bind(this);
        this.timeChange = this.timeChange.bind(this);

        this.getData = this.getData.bind(this);
        this.getData();
    }





    teamChange(event) {
        
        this.setState({teamValue: event.target.value}, () => {
            console.log(this.state);
            this.getData();
        });
        
    }

    timeChange(event) {
        
        this.setState({timeValue: event.target.value}, () => {
            console.log(this.state);
            this.getData();
        });
        
    }

    getData(){

        console.log("loading...");
        fetch('https://dev.iondeveloper.com/api/rep/_class/WeeklyReport.class.php?range=' + this.state.timeValue, {
            method: 'get',
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
           data.sort(); 

          this.setState({
            stats: data
          });
          console.log("finished loading");
          
        }.bind(this));

    }

    render() {


        let teams = [];
        for (var i = 0; i < this.state.stats.length; i++) {
            if (!teams.includes(this.state.stats[i].team_name)){
                teams.push(this.state.stats[i].team_name);
            }
        } 

        let options = [];
        for (var i = 0; i < teams.length; i++){

            options.push(
                <option key={i} value={teams[i]}>{teams[i]}</option>
            );

        }


        let graphNames = [];
        let graphNumbersHeld = [];
        let graphNumbersClosed = [];
        let graphAptHeld = [];
        let entries = [];
        console.log(this.state.stats);
        for (var i = 0; i < this.state.stats.length; i++) {
            if (this.state.teamValue === this.state.stats[i].team_name){

                entries.push(
                    <tr className="stat-row-header" key={i}>
                        <td>
                            {this.state.stats[i].name}
                        </td>
                        <td>
                            {this.state.stats[i].apt}
                        </td>
                        <td>
                            {this.state.stats[i].held}
                        </td>
                        <td>
                            {this.state.stats[i].per_held}%
                        </td>
                        <td>
                            {this.state.stats[i].closed}
                        </td>
                        <td>
                            {this.state.stats[i].per_closed}%
                        </td>
                    </tr>
                );

                graphNames.push(
                    this.state.stats[i].name
                );

                graphAptHeld.push(
                    this.state.stats[i].apt
                );

                graphNumbersHeld.push(
                    this.state.stats[i].per_held
                );

                graphNumbersClosed.push(
                    this.state.stats[i].per_closed
                );
            }
        } 

        let data = {
            datasets: [{
                label: 'Appointments',
                data: graphAptHeld,
                backgroundColor: "#8d959c",
                borderColor: "#8d959c"
            },{
                label: 'Held',
                data: graphNumbersHeld,
                backgroundColor: "#208ce2",
                borderColor: "#208ce2"
            },{
                label: 'Closed',
                data: graphNumbersClosed,
                backgroundColor: "#4CAF50",
                borderColor: "#4CAF50"
            }],
            labels: graphNames
        };

        let settings = { 
            maintainAspectRatio: true, 
            defaultFontColor: "#333",
            legend: {
                display: true,
            },
           title: {
               display: false,
               fontColor: 'blue',
               text: 'Custom Chart Title'
           }     ,
           scales: {
               yAxes: [{
                   ticks: {
                       beginAtZero:true,
                       fontColor: '#333',
                       fontSize: 15
                   },
               }],
             xAxes: [{
                   ticks: {
                       fontColor: '#333',
                       fontSize: 13
                   },
               }]
           } 
        }
        

        return (

            <div>
                <NavBar />


                <div className="container">
                    <br></br>
                    <Row>
                            <Col xs="12" sm="12" md="6" lg="6" center >
                                <select class="team-select" value={this.state.teamValue} onChange={this.teamChange}>
                                    {options}
                                </select>
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6" center >
                                <select class="team-select" value="Last Week" value={this.state.timeValue} onChange={this.timeChange}>
                                    <option value="TODAY">Today</option>
                                    <option value="YESTERDAY" >Yesterday</option>
                                    <option value="THIS_WEEK" >This Week</option>
                                    <option value="LAST_WEEK" >Last Week</option>
                                    <option value="THIS_MONTH" >This Month</option>
                                    <option value="LAST_MONTH" >Last Month</option>
                                    <option value="THIS_QUARTER" >This Quarter</option>
                                    <option value="LAST_QUARTER" >Last Quarter</option>
                                    <option value="THIS_YEAR" >This Year</option>
                                    <option value="LAST_YEAR" >Last Year</option>
                                </select>
                            </Col>
                            
                    </Row>

                </div> 
                {/* <Bar data={data} options={settings} height="100" /> */}
                        <div className="table-background stats-table-alt">
                            <table  className="stats-table">
                            <tr className="header-table stat-table-header">
                                <th>Name</th>
                                <th>Leads</th>
                                <th>Total Held</th>
                                <th>Percent Held</th>
                                <th>Total Closed</th>
                                <th>Percent Closed</th>
                            </tr>
                            {entries}
                            </table>
                        </div>

                
                
            </div>
            
        );
    }
}
export default Emails;




// WEBPACK FOOTER //
// ./src/components/shared/Emails.js